import { Modal, Typography } from 'antd'
import Button from 'components/button/Button'
import { IconCancel } from 'components/icons'
import { FormEvent } from 'react'

interface IProps {
  isOpen: boolean
  setModal: (value: boolean) => void
  handleSubmit: (e?: FormEvent<HTMLFormElement> | undefined) => void
  isLoading: boolean
}

const ModalCampaign = (props: IProps) => {
  const { isOpen, setModal, isLoading, handleSubmit } = props

  return (
    <Modal
      open={isOpen}
      footer={null}
      onCancel={() => setModal(false)}
      centered
      className="modal-confirmation w-fit"
      closeIcon={<IconCancel strokeWidth="2" color="black" />}
    >
      <div className="flex flex-col">
        <Typography.Paragraph className="mt-6 mb-2 text-lg text-center font-semibold leading-5 text-gray-700">
          Pastikan data Program Agen sudah terisi dengan benar.
        </Typography.Paragraph>
      </div>
      <div className="flex flex-col">
        <Typography.Paragraph className="text-center text-sm text-gray-500 mb-5">
          Anda tidak dapat membatalkan Program Agen yang sudah dibuat.
        </Typography.Paragraph>
      </div>
      <div className="flex gap-2">
        <Button
          block={true}
          onClick={() => setModal(false)}
          data-testid="btn_cancel"
          className="inline-block uppercase text-primary font-bold border border-primary"
          label="Batal"
        />
        <Button
          disabled={isLoading}
          loading={isLoading}
          block={true}
          onClick={handleSubmit}
          data-testid="btn_accept"
          className="inline-block uppercase font-bold"
          iconPosition="right"
          label="Buat Program Agen"
          variant="solid-primary"
        />
      </div>
    </Modal>
  )
}

export default ModalCampaign
